import initialState from 'config/initialState';

export { default as chargers } from './ChargerReducers';
export { default as places } from './PlaceReducers';
export { default as users } from './UserReducers';
export { default as auth } from './AuthReducers';
export { default as pages } from './PageReducers';

export function locale(state = initialState.locale) {
  return Object.assign({}, state);
}



// WEBPACK FOOTER //
// ./app/scripts/reducers/index.js